import { Box, Typography } from '@mui/material';
import React from 'react';

import { bankAccountModalContentSx } from '../../pages/dashboard/DashboardStyles';
import { CommonModal } from '../modal/modal';

interface ApplyToAllModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    message: string;
    /** Maps to CommonModal's primaryBtnClick / "No" */
    onNo: () => void;
    /** Maps to CommonModal's secondaryBtnClick / "Yes" */
    onYes: () => void;
}

/** Generic "apply this selection to all selected contracts?" confirmation modal. */
export const ApplyToAllModal: React.FC<ApplyToAllModalProps> = ({ open, onClose, title, message, onNo, onYes }) => {
    return (
        <CommonModal
            modalOpen={open}
            onCloseModal={onClose}
            DialogMainTitle={title}
            primaryBtnName="No"
            secondaryBtnName="Yes"
            primaryBtnClick={onNo}
            secondaryBtnClick={onYes}
            ModalMaxWidth={440}
        >
            <Box sx={bankAccountModalContentSx}>
                <Typography variant="body1" color="textSecondary" textAlign={'center'}>
                    {message}
                </Typography>
            </Box>
        </CommonModal>
    );
};
